// extracted by mini-css-extract-plugin
export default {"anchorOverrideBlack":"LeavingHomebotModal_anchorOverrideBlack__ofUGl","anchorOverrideWhite":"LeavingHomebotModal_anchorOverrideWhite__65JId"};